<template>
	<div class="w-full bg-primary-300 phablet:rounded-2xl py-8 px-6 relative">
		<slot />
	</div>
</template>
